<template>
  <Layout
    class="main-layout"
    max-width="100%"
  >
    <NotifySection />
    <ProductionSection />
    <ShortcutSection />
    <SimplifiedProposalTable />
  </Layout>
</template>
<script>
import seo from '@/utils/seo';

import Layout from '@/layouts/Layout.vue';
import NotifySection from '@/components/Hub/NotifySection.vue';
import ShortcutSection from '@/components/Hub/ShortcutSection.vue';
import SimplifiedProposalTable from '@/components/Hub/SimplifiedProposalTable.vue';
import ProductionSection from '@/components/Hub/ProductionSection.vue';

export default {
  name: 'ManagerHub',
  components: {
    Layout,
    NotifySection,
    ProductionSection,
    ShortcutSection,
    SimplifiedProposalTable,
  },
  data() {
    return {

      meta: {
        title: 'Página Inicial',
      },
    };
  },

  metaInfo() {
    return seo.meta(this.meta);
  },
};
</script>
<style lang="scss" scoped>
.main-layout {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
